import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('college_token');
    const collegeId = localStorage.getItem('college_id');

    console.log('🚀 API Request:', {
      url: config.url,
      method: config.method?.toUpperCase(),
      hasToken: !!token,
      collegeId: collegeId,
      params: config.params
    });

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('❌ API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', {
      url: response.config.url,
      status: response.status,
      dataKeys: Object.keys(response.data || {}),
      success: response.data?.success
    });
    return response;
  },
  (error) => {
    console.error('❌ API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data?.message || error.message
    });

    if (error.response?.status === 401) {
      console.log('🔐 Unauthorized - clearing credentials and redirecting to login');
      // Token is invalid or expired
      localStorage.removeItem('college_token');
      localStorage.removeItem('college_data');
      localStorage.removeItem('college_id');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// College Authentication APIs
export const collegeAuthAPI = {
  register: (data) => api.post('/college/register', data),
  login: (data) => api.post('/college/login', data),
  getProfile: () => api.get('/college/me'),
  getDashboard: () => api.get('/college/dashboard'),
};

// Student Management APIs
export const studentAPI = {
  getStudents: (params) => api.get('/college/students', { params }),
  approveStudent: (userId) => api.post(`/college/students/${userId}/approve`),
  rejectStudent: (userId, reason) => api.post(`/college/users/${userId}/reject`, { reason }),
  promoteToAmbassador: (userId) => api.post(`/college/students/${userId}/promote-ambassador`),
  demoteAmbassador: (userId) => api.post(`/college/students/${userId}/demote-ambassador`),
};

// Faculty Management APIs
export const facultyAPI = {
  getFaculty: (params) => api.get('/college/faculty', { params }),
  approveFaculty: (userId, permissions) => api.post(`/college/faculty/${userId}/approve`, permissions),
  updatePermissions: (userId, permissions) => api.put(`/college/faculty/${userId}/permissions`, permissions),
  rejectFaculty: (userId, reason) => api.post(`/college/users/${userId}/reject`, { reason }),
};

// Club Management APIs
export const clubAPI = {
  getClubs: (params) => api.get('/college/clubs', { params }),
  getClubDetails: (clubId) => api.get(`/college/clubs/${clubId}`),
};

// Campus Feed APIs
export const campusFeedAPI = {
  getCampusFeed: (params) => api.get('/college/campus-feed', { params }),
  deletePost: (postId) => api.delete(`/college/posts/${postId}`),
};

// Analytics APIs
export const analyticsAPI = {
  getStatistics: () => api.get('/college/dashboard'),
  getBranchStats: () => api.get('/college/branch-statistics'),
};

export default api;